import { render, staticRenderFns } from "./ModalConfirmDelete.vue?vue&type=template&id=928c6ef0&scoped=true&"
import script from "./ModalConfirmDelete.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmDelete.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirmDelete.vue?vue&type=style&index=0&id=928c6ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928c6ef0",
  null
  
)

export default component.exports